import { HOST, TENANTS_NAMES } from './host_config';
import xpo from './configs_post_login/xpo';
import intraser from './configs_post_login/intraser';
import ontruck from './configs_post_login/ontruck';
import acme from './configs_post_login/acme';
import rpt from './configs_post_login/rpt';
import ontime from './configs_post_login/ontime';
import alianza from './configs_post_login/alianza';
export const getTenantPostLoginConfig = () => {
  const tenantConfig = {
    [TENANTS_NAMES.intraser]: intraser,
    [TENANTS_NAMES.xpo]: xpo,
    [TENANTS_NAMES.ontruck]: ontruck,
    [TENANTS_NAMES.acme]: acme,
    [TENANTS_NAMES.rpt]: rpt,
    [TENANTS_NAMES.ontime]: ontime,
    [TENANTS_NAMES.alianza]: alianza,
  };
  return { ...tenantConfig[HOST] };
};
